import { IconComponent } from './types';

const RowCountIcon: IconComponent = (props) => (
  <svg
    width="6"
    height="6"
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_812_73)">
      <path
        d="M3.6 2.2H0V2.5H3.6V2.2ZM3.6 1H0V1.3H3.6V1ZM4.8 3.4V2.2H4.2V3.4H3V4H4.2V5.2H4.8V4H6V3.4H4.8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_812_73">
        <rect width="6" height="6" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default RowCountIcon;
